import { render, staticRenderFns } from "./Contacts.vue?vue&type=template&id=86f7f03e&scoped=true&"
import script from "./Contacts.vue?vue&type=script&lang=js&"
export * from "./Contacts.vue?vue&type=script&lang=js&"
import style0 from "./Contacts.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Contacts.vue?vue&type=style&index=1&id=86f7f03e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86f7f03e",
  null
  
)

export default component.exports